import { makeStyles } from '@material-ui/core/styles'

export const dashboardDialogStyles = makeStyles((theme) => ({
  dialogActionButton: {
    backgroundColor: theme.palette.backgroundColor.ternary,
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  titleCloseIcon: {
    color: theme.palette.base.red,
  },
  dialogTitle: {
    paddingBottom: theme.spacing(1),
    '& .MuiTypography-root': {
      margin: 0,
    },
  },
}))

export default dashboardDialogStyles
